import AdminLayout from "./AdminLayout";
import online from '../../../assets/Dashboard/online-learning.svg';
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import CopyToClipboard from "react-copy-to-clipboard";
import { FaCopy } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import M from 'materialize-css/dist/js/materialize.min';

const AllClasses = ({ classes }) => {
    return ( 
        <AdminLayout>
            <div className="container pt-4">
                <h5 className="title is-size-5-touch has-text-weight-semibold mb-2 grey-text text-darken-3">All Online classes</h5>
                <div className="divider mb-5"></div>
            </div>
            {
                 classes &&
                <div className="container row pt-5">
                {
                    classes.length !== 0 ? ( 
                        classes.map(classRoom => (
                                <div className="col s12 m4 l4" key={classRoom.moduleName}>
                                    <div className="card-panel grey lighten-5 z-depth-1 smooth-edge-2">
                                        <p className="grey-text text-darken-2 center is-size-5">{classRoom.moduleName}</p>
                                        <p className="grey-text has-text-weight-light my-3 center is-size-6">{classRoom.teacher}</p>
                                        <p className="grey-text text-darken-2 center mt-2 mb-3 is-size-6">Code: {classRoom.classCode}</p>
                                        <div className="center">
                                            <CopyToClipboard text={classRoom.classCode}>
                                                <div className="button is-small is-info my-3" onClick={() => M.toast({html: 'Copied Code', classes: 'rounded'})}>
                                                    <span className="icon">
                                                        <FaCopy color="white"/>
                                                    </span>
                                                    <span className="white-text">Copy Code</span>
                                                </div>
                                            </CopyToClipboard>
                                        </div>
                                        <div className="center">
                                            <a className="button is-success mt-3 mb-1" href={classRoom.classLink} target="_blank"  rel="noreferrer" >
                                                <span className="icon">
                                                    <SiGoogleclassroom color="white"/>
                                                </span>
                                                <span className="white-text">Join Class</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                            ))                  
                    ) : (
                        <div className="container pt-6">
                            <p className="center has-text-weight-semibold grey-text text-darken-2 is-size-4 mb-4">No classes added yet !</p>
                            <div className="dashboard-illustration container">
                                <img src={online} alt="Illustration" />
                            </div>
                        </div>
                    )
                }
                </div>
            }

        </AdminLayout>
     );
}
 
const mapStateToProps = (state) => {
    //console.log(state)
    return {
        classes: state.firestore.ordered.classes,
        profile: state.firebase.profile,
    }
    
}


export default compose(
    connect(mapStateToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "classes", 
            },
    ])
)(AllClasses);
